import { ChangeEvent } from "react";
import { CSSProperties } from "styled-components";

import AutocompleteStyles from "../styles/components/AutocompleteStyles";

type Option = string | Record<string, any>;

interface AutocompleteFloatLabelCleanProps {
    label?: string;
    onChange?: ((selected: Option[]) => void) | undefined;
    onInputChange?:
        | ((text: string, event: ChangeEvent<HTMLInputElement>) => void)
        | undefined;
    options: Option[];
    placeholder?: string;
    selected?: Option[] | undefined;
    extraOptions?: boolean;
    extraLabel?: string;
    disabled?: boolean;
    style?: CSSProperties;
}

function AutocompleteFloatLabelClean(props: AutocompleteFloatLabelCleanProps) {
    const { StyledLabel, StyledFormSelectFloatLabelClean, StyledFormGroup } =
        AutocompleteStyles;

    const styleGroup: CSSProperties = {
        width: "100%",
        maxWidth: "735px",
        marginBottom: "24px",
    };

    const filterByFields = ["value", "label"];
    return (
        <StyledFormGroup style={props.style || styleGroup}>
            {props.label ? <StyledLabel>{props.label}</StyledLabel> : null}
            <StyledFormSelectFloatLabelClean
                id="basic-example"
                onChange={props.onChange}
                onInputChange={props.onInputChange}
                options={props.options}
                placeholder={props.placeholder}
                selected={props.selected}
                clearButton
                disabled={props.disabled}
                paginationText="Mais resultados"
                emptyLabel="Nenhum resultado encontrado"
                labelKey={(option: any) => `${option?.label}`}
                filterBy={filterByFields}
                renderMenuItemChildren={(item: any) => (
                    <div>
                        {item?.label}
                        {props.extraOptions ? (
                            <div>
                                <small>
                                    {props.extraLabel}: {item.value}
                                </small>
                            </div>
                        ) : null}
                    </div>
                )}
            />
        </StyledFormGroup>
    );
}

export default AutocompleteFloatLabelClean;
